import React from 'react';

export default function ComponentMobile({children}) {
    return <div className={'d-block d-xs-block d-sm-block d-md-none d-lg-none'}>
        {children}
    </div>
}
